import { createContext, useContext, useEffect, useState } from 'react'

// Agora só usamos o tema 'brand'
type ColorScheme = 'brand'

interface ColorSchemeContextType {
  colorScheme: ColorScheme
  setColorScheme: (scheme: ColorScheme) => void
}

const ColorSchemeContext = createContext<ColorSchemeContextType | undefined>(undefined)

export function ColorSchemeProvider({ children }: { children: React.ReactNode }) {
  // Sempre inicializa com o tema 'brand'
  const [colorScheme, setColorScheme] = useState<ColorScheme>('brand')

  // Efeito para inicializar o tema ao carregar a página
  useEffect(() => {
    // Aplicar o tema inicial ao carregar a página
    applyTheme(colorScheme)
  }, [])

  // Função para aplicar o tema (agora sempre 'brand')
  const applyTheme = (theme: ColorScheme) => {
    // Salvar no localStorage
    localStorage.setItem('theme', theme)
    
    console.log('Aplicando tema fixo:', theme)
    
    // Remover outras classes de tema
    document.documentElement.classList.remove('dark', 'light')
    
    // Adicionar a classe do tema marca
    document.documentElement.classList.add('brand')
    
    // Definir o atributo data-theme
    document.documentElement.setAttribute('data-theme', theme)
  }

  return (
    <ColorSchemeContext.Provider value={{ colorScheme, setColorScheme }}>
      {children}
    </ColorSchemeContext.Provider>
  )
}

export function useColorScheme() {
  const context = useContext(ColorSchemeContext)
  if (context === undefined) {
    throw new Error('useColorScheme must be used within a ColorSchemeProvider')
  }
  return context
}